import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=56db4594&scoped=true&"
import script from "./ClockIcon.vue?vue&type=script&lang=js&"
export * from "./ClockIcon.vue?vue&type=script&lang=js&"
import style0 from "./ClockIcon.vue?vue&type=style&index=0&id=56db4594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db4594",
  null
  
)

export default component.exports